import { Route, Routes } from "react-router-dom";
import { E2DynamicDataEdit } from "./edit";
import { E2DynamicDataTable } from "./table";
import { E2DynamicDatasNew } from "./new";

export default function E2DynamicData() {
  return (
    <Routes>
      <Route path=":id" element={<E2DynamicDataEdit />} />
      <Route index element={<E2DynamicDataTable />} />
      <Route path="new" element={<E2DynamicDatasNew />} />
    </Routes>
  );
}
